import React, { Component } from 'react';
import { Media } from 'reactstrap';
import history from "../historyBeta";
import './NavMenu.css';
import url from "./variables/url.js";
import Paginacion from './Paginacion';
import ActividadCard from './ActividadCard';
import Vacio from './Vacio';
import { AppContext } from '../AppContext';
import PropTypes from 'prop-types';

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;
const homepage = process.env.REACT_APP_EXP;

class LoteActividades extends Component {
    static displayName = LoteActividades.name;

    constructor(props) {
        super(props);
        /*const actividadesList = this.props.actividades;*/
        const userId = this.props.userId;
        const categoriaId = this.props.categoria;
        const edit = this.props.editable;
        this.state = {            
            loading: true,                        
            categorias: [],
            tipos: [],
            currentUser: [],
            collapse: 0,
            dropdownOpen: false,
            id: userId,
            categoria: categoriaId,
            actividades: [],
            currentActividades: [],
            currentPage: null,
            totalPages: null,
            editable: edit ?? true,
        };

        this.handleEdit = this.handleEdit.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleCard = this.toggleCard.bind(this);
        this.toggleDD = this.toggleDD.bind(this);
        this.newActEst = this.newActEst.bind(this);        
    }

    componentDidMount() {
        let user = this.context;
        this.setState({ currentUser: user });
        console.log('user', this.state.currentUser.idpersona);
        this.populateInfoData();
        this.populateActividades();
    }

    componentDidUpdate(prevState) {
        //let user = this.context;
        //if (user != null && prevState.actividades.length !== this.state.actividades.length)
        // this.populateActividades();
    }

    onPageChanged = data => {
        const { actividades } = this.state;
        const { currentPage, totalPages, pageLimit } = data;
        const offset = (currentPage - 1) * pageLimit;
        const currentActividades = actividades.slice(offset, offset + pageLimit);

        this.setState({ currentPage, currentActividades, totalPages });
    }    

    renderActividadesTable(actividades, currentActividades, currentPage, totalPages) {
      const currentUser = this.context;
      const { collapse } = this.state;      
      const totalAct = actividades.length;      
      const limite = 12;
      const vecindario = 1;
      return (
      <div>                                     
              {actividades.length == 0 ?
                  <>
                      <Media>                          
                          <Media body>
                              <Vacio editable={this.state.editable} />
                          </Media>
                      </Media>
                  </> :
                  <>
                      <div className="container mb-5" style={{ flex: 2 }}>
                          <div className="row d-flex flex-row">
                              <div className="w-100 px-4 d-flex flex-row flex-wrap align-items-center justify-content-between">
                                  <div className="d-flex flex-row align-items-center">
                                      <h2>
                                          <strong className="text-secondary">{totalAct}</strong> Actividades
                                      </h2>
                                      {currentPage && (
                                          <span className="current-page d-inline-block h-100 pl-4 text-secondary">
                                              Page <span className="font-weight-bold">{currentPage}</span> / <span className="font-weight-bold">{totalPages}</span>
                                          </span>
                                      )}
                                  </div>
                                  <div className="d-flex flex-row py-4 align-items-center">                                      
                                  </div>
                                  <div className="d-flex flex-row py-4 align-items-center">
                                      <Paginacion totalRecords={totalAct} pageLimit={limite} pageNeighbours={vecindario} onPageChanged={this.onPageChanged} />
                                  </div>

                              </div>
                              {currentActividades.map(act =>
                                  <div className = "col-3">
                                  <ActividadCard actividad={act} edit={this.handleEdit} />                                      
                                  </div>
                              )}
                          </div>
                      </div>
                  </>
              }           
      </div>
    );
    }

    render() {
        
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderActividadesTable(this.state.actividades, this.state.currentActividades, this.state.currentPage, this.state.totalPages);        


        return (
            <div>                
                {contents}                
            </div>
        );
    }

    populateActividades() {
        const user = this.context;        

        fetch(localBack + '/api/RegistroActividad/GetActByCat/' + this.state.id + '/' + this.state.categoria, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status, });
                return response.json();
            })
            .then(data => {
                console.log(data.strMensaje);
                if (data.strEstado == 'S') {
                    this.setState({ actividades: data.objDatos, loading: false, total: 1 });
                    /*console.log(this.state.actividades);*/
                } else {
                    this.setState({ actividades: [] });
                }
            });

    }

    populateInfoData() {
        fetch(localBack + '/api/Insignia', {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => response.json())
                .then(data => {
                    /*console.log(data);*/
                    this.setState({
                        categorias: data.objDatos  });
                });

        fetch(localBack + '/api/TipoActividad', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
               /* console.log(data);*/
                this.setState({
                    tipos: data.objDatos,
                });
            });        
        
    }    

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            /*console.log(tab);*/
            this.setState({
                activeTab: tab
            });
        }
    }

    toggleCard(e) {
        let event = e.target.dataset.event;
        this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) });
        /*console.log(Number(event));*/        
    }

    toggleDD() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    newAct() {
        /*console.log('Nueva Actividad');*/
        /*history.push('/Add-Act');*/
    }

    newActEst(categoria, tipo) {
        /*console.log('Nueva Actividad Estudiante');*/
        history.push(homepage+'New-Act/' + categoria + '/' + tipo);        
    }

    handleEdit(id) {
        /*console.log("Editar " + id);*/
        history.push(homepage+"Edit-Act/" + id);
        window.location.href = window.location.href;
        /*this.props.history.push("/Edit-Act/" + id);*/
    }

}

LoteActividades.propTypes = {
    /*actividades: PropTypes.array.isRequired,*/
    userId: PropTypes.number.isRequired,
    categoria: PropTypes.number.isRequired,
    editable: PropTypes.bool
};

LoteActividades.contextType = AppContext;
export default LoteActividades;